import React, { useState } from 'react'
import styled from 'styled-components'
import Filter from './Filter'
import ArticleShort from '../shared/ArticleShort'
import Pagination from './Pagination'
import sellLogo from '../../assets/sellLogo.png'
import salveatMoneyLogo from '../../assets/salveatMoneyLogo.png'
import whiteArrow from '../../assets/whiteArrow.png'
import colors from '../../styles/colors'
import { useNavigate } from 'react-router-dom' // Importer useNavigate

const StyledSell = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`

const StyledFilter = styled(Filter)``
const StyledPagination = styled(Pagination)``

const DropdownToggle = styled.div`
    display: flex;
    background-color: ${colors.first};
    border-radius: 0 15px 0 0;
    width: 100%;
    height: 65px;
    gap: 50px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:hover {
        filter: brightness(0.9);
    }
`

const StyledSellLogo = styled.img`
    width: 55px;
`

const StyledDropdownToggleTitle = styled.div`
    font-size: 25px;
    color: white;
`

const StyledArrow = styled.img`
    height: 15px;
    opacity: ${({ userInfo }) => (userInfo ? '1' : '0')};
    transform: ${({ showFilter }) =>
        showFilter ? 'rotate(180deg)' : 'rotate(0deg)'};
    transition: transform 0.3s ease;
`

const StyledPleaseConnect = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
        padding-top: 40px;
        width: 130px;
    }
    p {
        font-size: 22px;
        font-weight: normal;
        color: #4e8223;
        &:hover {
            cursor: pointer;
            text-decoration: underline;
        }
    }
`

const Sell = ({ userInfo, stuffCategories }) => {
    // État pour les résultats filtrés
    const [filteredResults, setFilteredResults] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [showFilter, setShowFilter] = useState(false)

    const navigate = useNavigate() // Initialiser le hook useNavigate

    const StyledAddThing = styled.div`
        display: flex;
        font-size: 20px;
        width: 98%;
        padding: 10px;
        margin-top: 5px;
        border-radius: 2vh;
        background-color: ${colors.first};
        justify-content: center;
        align-items: center;
        color: white;
        transition: all 0.1s ease;
        &:hover {
            filter: brightness(0.9);
            cursor: pointer;
        }
    `
    const handleClick = () => {
        navigate(`/NewProduct`) // Rediriger vers la page cible avec l'ID de l'item
    }

    const toggleFilterVisibility = () => {
        setShowFilter((prevShowFilter) => !prevShowFilter)
    }

    return (
        <StyledSell>
            <DropdownToggle onClick={toggleFilterVisibility}>
                <StyledSellLogo src={sellLogo} alt="logo" />
                <StyledDropdownToggleTitle>Vendre</StyledDropdownToggleTitle>
                <StyledArrow
                    src={whiteArrow}
                    alt="arrow"
                    showFilter={showFilter}
                    userInfo={userInfo}
                />
            </DropdownToggle>

            <StyledFilter
                sellOrBuySection={'sell'}
                userInfo={userInfo}
                setFilteredResults={setFilteredResults}
                stuffCategories={stuffCategories}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                showFilter={showFilter}
            />
            {userInfo && (
                <StyledAddThing onClick={handleClick}>
                    Ajouter un article
                </StyledAddThing>
            )}
            {filteredResults.results?.map((item) => (
                <ArticleShort
                    key={item._id}
                    sellOrBuySection={'sell'}
                    stuffCategories={stuffCategories}
                    item={item}
                />
            ))}
            {userInfo && filteredResults.results?.length > 0 ? (
                <StyledPagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalPages={filteredResults.pagination?.totalPages}
                />
            ) : (
                <StyledPleaseConnect>
                    <img src={salveatMoneyLogo} alt="Connect to see items" />
                    <p>Rien à vendre...!</p>
                </StyledPleaseConnect>
            )}
        </StyledSell>
    )
}

export default Sell
